<template>
  <div class="table-responsive">
    <table
      class="table"
      v-bind:class="{ 'spinner-is-visible': isSpinnerVisible }"
    >
      <thead>
        <tr>
          <SortableHeader
            style="width: 300px"
            :current-sort="orderBy"
            :sort-by="'LABEL'"
            @sort="reorder"
          >Dashboard</SortableHeader>

          <SortableHeader
            v-if="policyUpdate"
            style="width: 300px"
            :current-sort="orderBy"
            :sort-by="'NAME'"
            @sort="reorder"
          >Fulcrum App</SortableHeader>

          <SortableHeader
            :current-sort="orderBy"
            :sort-by="'CLIENT_COMPANY_NAME'"
            @sort="reorder"
          >Client Company</SortableHeader>

          <SortableHeader
            class="text-end"
            style="width: 180px"  
            :current-sort="orderBy"
            :sort-by="'DASHBOARD_TYPE'"
            @sort="reorder"
          >Dashboard Type</SortableHeader>

          <th
            class="text-end"
            style="width: 180px"
          >Last Synced</th>

          <th data-sorter="false" class="d-none d-md-table-cell"></th>
        </tr>
      </thead>

      <tbody>
        <FulcrumApp
          v-for="(item, index) in items"
          v-bind="item"
          :key="item.id"
          :index="index"
          :policy-update="policyUpdate"
          :ref="item.id"
          :selected="isItemMarked(item.id)"
        />
      </tbody>
      <div class="spinner"></div>
    </table>

    <Pagination
      v-bind="pageInfo"
      entity-type="project dashboards"
      @navigate-to="paginate"
    />
  </div>
</template>

<script>
import Grid from "../shared/grid/grid";

import FulcrumApp from "./fulcrum_app";

export default {
  extends: Grid,

  components: {
    FulcrumApp
  },

  data: function () {
    return {
      items: [],

      grid: "project-dashboards",

      defaultOrderBy: {
        field: "LABEL",
        direction: "ASC"
      },

      orderBy: {
        field: "LABEL",
        direction: "ASC"
      },

      pageInfo: {
        pageSize: 50,
        currentPage: 1,
        totalCount: 0,
        totalPageCount: 0
      },

      isSpinnerVisible: true
    }
  },

  methods: {
    fetch: function (params, success) {
      app.graphql.get("grid.fulcrumApps",
        params,

        (data) => {
          let fulcrumApps = data.data.fulcrumApps,
              pageInfo = fulcrumApps.pageInfo;

          success(fulcrumApps, pageInfo);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch Apps!"
          })
        }
      )
    }
  }
}
</script>
